// extracted by mini-css-extract-plugin
export var editButton = "_ok-0";